import { AlertaPromesa } from "infortech_modules/Componentes/Alertas";
import Boton from "infortech_modules/Componentes/Boton";
import Tabla from "infortech_modules/Componentes/Tabla";
import { buscarValor, cambiarFormulario, datosConsultarHistorial, duplicate, extraerCliente, tiempo } from "infortech_modules/Constantes/Constantes";
import CrearInput from "infortech_modules/Constantes/CrearInput";
import { CreaarFila } from "infortech_modules/Constantes/CrearTabla";
import EsNumero from "infortech_modules/Constantes/EsNumero";
import EsVacio from "infortech_modules/Constantes/EsVacio";
import Permisos, { Autorizado, usuario } from "infortech_modules/Constantes/Usuarios";
import Post from "infortech_modules/Crud/Post";
import ModalDelete from "infortech_modules/Modales/ModalDelete";
import ModalEdit from "infortech_modules/Modales/ModalEdit";
import { useState } from "react";

export default function PEquipos({ productos, temporal, open }) {
    const datos = [];
    productos = productos === undefined ? [] : productos;
    temporal = temporal === undefined ? [] : temporal;
    const [agregar, setAgregar] = useState({ vid: "", des: "", usr: usuario().id, tipo: "PEquipos" });
    const [editar, setEditar] = useState({ vid: "", des: "" });
    const [disabled, setDisabled] = useState(false);
    const cambiar = (e) => {
        cambiarFormulario(e, agregar, setAgregar)
    }

    const guardar = () => {
        setDisabled(true);
        if (EsVacio([buscarValor(productos, agregar.vid) ? "ok" : "", agregar.des, agregar.des > 0 ? "ok" : ""], ['Seleccione un Producto de la Lista', 'Digite la Cantidad', "La  cantidad debe ser mayor a 0"])) {
            if (EsNumero([agregar.des], ['La cantidad debe ser un valor númerico'])) {

                const promesa = new Promise((res, rej) => {
                    Post({ url: '/post', table: 'temporal', caso: 'planesAdd', data0: { vid: extraerCliente(agregar.vid), des: agregar.des, usr: agregar.usr, tipo: agregar.tipo }, duplicate: duplicate(true, [extraerCliente(agregar.vid)], ['vid'], ['Este Producto ya ha sido agregado'], [`and usr = ${usuario().id} and tipo = 'PEquipos'`]) }).then((r) => {
                        open(true);
                        setAgregar({ vid: "", des: "", usr: usuario().id, tipo: "PEquipos" })
                        tiempo(250, res, 'Información Guardada')
                    }).catch((f) => {
                        tiempo(250, rej, f)
                    })
                })
                AlertaPromesa('Guardando Información', promesa, 'a')
            } else {
                tiempo(2000, setDisabled, false)
            }
        } else {
            tiempo(2000, setDisabled, false)
        }
    }
    const inicializar = (d) => {
        setEditar(d)
    }

    return (
        <>
            <datalist id="equipos">
                {
                    productos.map((v, i) => {
                        return <option key={i} value={v.id + ' - ' + v.nom + ' - ' + v.mar + ' - '+v.modl} />
                    })
                }
            </datalist>
            <div className="border-2 p-3 mb-3 rounded-lg bg-gray-50">
                <h5>Agregar Equipos</h5>
                <div className="row mb-3">
                    <div className="col-lg-8 col-xl-8 col-12 mb-3">
                        <div className="form-floating">
                            <input className="form-control" type={'text'} name={'vid'} value={agregar.vid} list={'equipos'} onChange={cambiar} />
                            <label>Seleccione Equipo</label>
                        </div>
                    </div>
                    <div className="col-lg-2 col-xl-2 col-6">
                        <div className="form-floating">
                            <input className="form-control" type={'text'} name={'des'} value={agregar.des} onChange={cambiar} />
                            <label>Cantidad</label>
                        </div>
                    </div>
                    <div className="col-lg-2 col-xl-2 col-6">
                        <Boton tipo={'primary'} disabled={disabled} titulo={'Agregar Equipo'} onClick={() => guardar()} />
                    </div>
                </div>
                <div className="row mb-3">
                    <h5>Equipos y cantidades incluidas en el Plan</h5>
                    <Tabla
                        encabezado={['No. ', 'Equipo', 'Cantidad', 'Acciones']}
                        nombre={'ttps'} filas={temporal.map((v, i) => {
                            datos[i] = ({ vid: v.vid + ' - ' + v.nom + ' - ' + v.mar + ' - '+v.modl })
                            return (
                                <tr key={i}>
                                    {CreaarFila([i + 1, v.nom + ' - ' + v.mar + ' - '+v.modl, v.des, <>
                                        {
                                            Autorizado([Permisos().planesEdit]) &&
                                            <ModalEdit modalTitulo={'Editar'} modalSize={'lg'}
                                                inicializarDatos={() => inicializar(datos[i])}
                                                formulario={[
                                                    [CrearInput({ type: 'text', name: 'vid', value: editar.vid, placeholder: 'Producto', list: 'productos', clase: 'col-lg-6 col-xl-6 col-sm-12 col-12' }),
                                                    CrearInput({ type: 'text', name: 'des', value: editar.des, placeholder: 'Cantidad', clase: 'col-lg-6 col-xl-6 col-sm-12 col-12' })
                                                    ]
                                                ]} onChange={(e) => cambiarFormulario(e, editar, setEditar)}
                                                comprobarTextoVacio={[buscarValor(productos, editar.vid) ? "ok" : "", editar.des, editar.des.toString() > 0 ? "ok" : ""]}
                                                mensajeTextoVacio={["Seleccione un Producto de la Lista", "Escriba la Cantidad que incluye el plan", "La Cantidad debe ser mayor a 0"]}
                                                numeroComprobar={[editar.des]} mensajeNumeroComprobar={['La cantidad debe ser un valor múmerico']}
                                                duplicados={duplicate(true, [extraerCliente(editar.vid)], ['vid'], ['Este producto ya ha sido agregado'], [`and usr = ${usuario().id} and tipo = 'PEquipos' and id != ${v.id} `])}
                                                url={'/put'} tabla={'temporal'} caso={'planesEdit'}
                                                mensajeLoadingPromesa={'Actualizando...'} mensajePromesa={'Actualizado'} editar={{ vid: extraerCliente(editar.vid), des: editar.des }} id={`id = ${v.id}`} principal={open}

                                            />
                                        }
                                        {
                                            Autorizado([Permisos().planesDel]) &&
                                            <>
                                                &nbsp; &nbsp;
                                                <ModalDelete
                                                    modalTitulo={'Eliminar Producto Incluido en el Plan'}
                                                    mensajeEliminar={<>¿Seguro de eliminar el producto <strong>{v.familia + ' - ' + v.nom}</strong> de este plan?</>}
                                                    consultarHistorial={datosConsultarHistorial(true)}
                                                    url={'/del'} condicionEliminar={`id = ${v.id}`} tabla={'temporal'} caso={'planesDel'}
                                                    mensajeLoadingPromesa={'Eliminando'} mensajePromesa={'Eliminado'} principal={open}
                                                />
                                            </>
                                        }
                                    </>])}
                                </tr>
                            )
                        })}
                    />
                </div>
            </div>
        </>
    )
};
